var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',_vm._l((_vm.departmentTeams),function(teamItem,teamIndex){return _c('JobsTreeTeamItem',{key:`team_${teamIndex}`,attrs:{"team":teamItem,"jobs":_vm.jobs,"organizationName":_vm.organizationName,"departmentName":_vm.departmentName,"onArchiveJob":_vm.onArchiveJob,"unfold":_vm.unfold},on:{"newchild":_vm.handleNewChild}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }